module.exports = __webpack_public_path__ + "static/media/logo.d2046ab9.png";